export class AppConfig {
  defaultPageSize = 20;
  pageSizeOptions = [10, 20, 50, 100];
  maxSimpleSuggestions = 2;
  maxUrlLength = 2000;

  constructor(
    attr: {
      defaultPageSize?: number;
      pageSizeOptions?: number[];
      maxSimpleSuggestions?: number;
      maxUrlLength?: number;
    } = {}
  ) {
    if (attr.defaultPageSize) {
      this.defaultPageSize = attr.defaultPageSize;
    }

    if (attr.pageSizeOptions) {
      this.pageSizeOptions = attr.pageSizeOptions;
    }

    if (attr.maxSimpleSuggestions) {
      this.maxSimpleSuggestions = attr.maxSimpleSuggestions;
    }
    if (attr.maxUrlLength) {
      this.maxUrlLength = attr.maxUrlLength;
    }
  }
}
